import { ExamFormFields } from '@/components/exam/ExamForm';
import { ExamDTO, ExamTypeEnum } from '@/models/Exam';

export const examFieldsToDTO = (data: ExamFormFields): Partial<ExamDTO> => ({
  name: data.name,
  description: data.description || null,
  type: data.type,
  defaultTime: data.defaultTime,
  assessmentItemId:
    data.type === ExamTypeEnum.SIMULATED ? null : data.assessmentItemId,
});
